<template>
    <div class="d-flex flex-column w-100">
		<nav-bar/>
		<banner titulo="Gerenciar Pessoas" subTitulo="Gerencie Pessoas do Sistema"/>
        <div class="d-flex flex-md-row flex-wrap flex-column w-75 mx-auto mt-2 p-md-5 p-3 gap-md borda">
            <form class="d-flex flex-column gap-md w-100">
                <div class="d-flex flex-md-row flex-column w-100 gap-md">
                    <div class="d-flex flex-column w-100">
                        <label>Pessoa Física:</label>
						<auto-complete-pessoa-fisica :disabled="tipoPessoaFiltro == `pessoaJuridica`" ref="filtroPessoaFisica" @pessoaSelecionada="setaCpfPessoaFisicaPesquisada($event)"/>
                    </div>
                </div>
                <div class="d-flex flex-md-row flex-column w-100 gap-md">
                    <div class="d-flex flex-column w-100">
                        <label>Pessoa Jurídica:</label>
						<auto-complete-pessoa-juridica :disabled="tipoPessoaFiltro == 'pessoaFisica'" ref="filtroPessoaJuridica" @pessoaSelecionada="setaCpfPessoaJuridicaPesquisada($event)"/>
                    </div>
                </div>
                <div class="d-flex gap-sm">
                    <div class="d-flex gap-sm">
                        <label>Pessoa Jurídica</label>
                        <input placeholder="Digite..." @input="limparFormularioFiltro" @change="filtrarPessoa" type="radio" value="pessoaJuridica"
                            v-model="tipoPessoaFiltro">
                    </div>
                    <div class="d-flex gap-sm">
                        <label>Pessoa Física</label>
                        <input placeholder="Digite..." @input="limparFormularioFiltro" @change="filtrarPessoa" type="radio" value="pessoaFisica" v-model="tipoPessoaFiltro">
                    </div>
                    </div>
                    <div class="d-flex flex-md-row flex-column gap-sm mx-md-0 mx-auto" style="justify-content: space-between;">
                        <div class="d-flex gap-sm">
                            <b-button variant="primary" @click="filtrarPessoa">Filtrar</b-button>
                            <b-button variant="secondary" @click="limparFormularioFiltro">
                                Limpar
                            </b-button>
                        </div>
                    <div class="d-flex">
                         <b-button variant="primary" @click="abrirModalSalvarPessoa(0)">
                            Criar Nova Pessoa
                        </b-button>
                    </div>
                    </div>
            </form>
            <modal-salvar-pessoa @input="handleSucesso" ref="modalSalvarPessoa"/>
            <b-table striped hover :items="items" :fields="fields" show-empty :responsive="true" :busy="carregando">
                <template #empty >
                    <div class="d-flex">
                        <span class="mx-auto">
                        Nenhum Registro Encontrado
                    </span>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
				<template #cell(tipoEspecifico)="data">
                    {{ retornaTipoEspecifico(data.item) }}
                </template>
				<template #cell(codigo)="data">
                    {{ retornaCodigoTipoEspecifico(data.item) }}
                </template>
				<template #cell(localidade)="data">
                    {{ data.item.estado + "/" + data.item.cidade}}
                </template>
                <template #cell(cpfCnpj)="data">
                    {{ (data.item.cnpj == null ? $options.filters.addMascara(data.item.cpf, "cpf") :
                        $options.filters.addMascara(data.item.cnpj, "cnpj")) }}
                </template>
                <template #cell(telefone)="data">
                    {{ $options.filters.addMascara(data.item.telefone, "tel") }}
                </template>
                <template #cell(dataInicio)="data">
                    {{ $options.filters.moment(data.item.dataInicio).format("DD/MM/YYYY") }}
                </template>
				<template #cell(acao)="data">
  					<b-dropdown id="dropdown-1" text="Selecione" boundary="window">
						<b-dropdown-item @click="abrirModalSalvarPessoa(data.item.id)" class="d-flex">
							<font-awesome-icon icon="fa-solid fa-solid fa-pen-to-square" />
							<span>
								Editar
							</span>
						</b-dropdown-item>
						<b-dropdown-item @click="$bvModal.show('modal-deletar-pessoa-' + data.item.id)" class="d-flex">
							<font-awesome-icon icon="fa-solid fa-trash" />
							<span>
								Excluir
							</span>
						</b-dropdown-item>
  					</b-dropdown>
					<modal-excluir-pessoa @sucesso="setaSucessoExcluir" :pessoa="data.item"/>
				</template>
            </b-table>
            <b-pagination class="mx-auto" v-model="paginaAtual" :total-rows="numeroDeLinhas" :per-page="pessoasPorPagina" @input="consultarPessoas"></b-pagination>
        </div>
    </div>
</template>

<script>
import AutoCompletePessoaFisica from "../../components/pessoa/AutoCompletePessoaFisica.vue";
import AutoCompletePessoaJuridica from "../../components/pessoa/AutoCompletePessoaJuridica.vue";
import ModalExcluirPessoa from "../../components/pessoa/ModalExcluirPessoa.vue";
import ModalSalvarPessoa from "../../components/pessoa/ModalSalvarPessoa.vue";
import Banner from "../../components/shared/Banner.vue";
import NavBar from "../../components/shared/NavBar.vue";

import PessoaService from "../../service/PessoaService.js";

export default {
	components: { ModalSalvarPessoa, ModalExcluirPessoa, Banner, AutoCompletePessoaFisica, AutoCompletePessoaJuridica, NavBar },
	name: "GerenciarPessoa",
	data() {
		return {
			tipoPessoaFiltro: "pessoaJuridica",
			carregando: false,
			items: [],
			fields: [],
			numeroDeLinhas: 0,
			paginaAtual: 1,
			pessoasPorPagina: 15,
			cpfPessoaPesquisada: "",
			cnpjPessoaPesquisada: "",
		};
	},
	created() {
		this.filtrarPessoa();
		this.setaColunasDaTabela();
	},
	methods: {
		retornaCodigoTipoEspecifico(item) {
			if (item.cei) {
				return item.cei;
			}
			if (item.caepf) {
				return item.caepf;
			}
			if (item.cno) {
				return item.cno;
			}

			return "";
		},
		retornaTipoEspecifico(item) {
			if (item.cei) {
				return "CEI";
			}
			if (item.caepf) {
				return "CAEPF";
			}
			if (item.cno) {
				return "CNO";
			}

			return "Funcionário Primeseg";
		},
		setaCpfPessoaFisicaPesquisada(cpf) {
			this.cpfPessoaPesquisada = cpf;
		},
		setaCpfPessoaJuridicaPesquisada(cnpj) {
			this.cnpjPessoaPesquisada = cnpj;
		},
		setaSucessoExcluir() {
			this.filtrarPessoa();
		},
		handleSucesso() {
			this.filtrarPessoa();
		},
		abrirModalSalvarPessoa(id) {
			this.$refs.modalSalvarPessoa.abrirModal(id);
		},
		setaColunasDaTabela() {
			if (this.tipoPessoaFiltro == "pessoaJuridica") {
				this.fields = [
					{ label: "#", key: "index" },
					{ label: "Razão Social", key: "razaoSocial" },
					{ label: "CNPJ", key: "cpfCnpj" },
					{ label: "Telefone", key: "telefone" },
					{ label: "Localidade", key: "localidade" },
					{ label: "Data de Cadastro", key: "dataInicio" },
					{ label: "", key: "acao" },
				];
			} else {
				this.fields = [
					{ label: "#", key: "index" },
					{ label: "Nome Completo", key: "nome" },
					{ label: "CPF", key: "cpfCnpj" },
					{ label: "Tipo Específico", key: "tipoEspecifico" },
					{ label: "Código", key: "codigo" },
					{ label: "Telefone", key: "telefone" },
					{ label: "Localidade", key: "localidade" },
					{ label: "Data de Cadastro", key: "dataInicio" },
					{ label: "", key: "acao" },
				];
			}
		},
		filtrarPessoa() {
			this.paginaAtual = 1;
			this.consultarPessoas();
		},
		consultarPessoas() {
			this.carregando = true;
			PessoaService
				.consultarPessoas(
					this.tipoPessoaFiltro,
					this.cpfPessoaPesquisada,
					this.cnpjPessoaPesquisada,
					this.paginaAtual - 1,
					this.pessoasPorPagina)
				.then((res) => {
					this.numeroDeLinhas = res.data[0];
					this.items = res.data[1];
					this.setaColunasDaTabela();
				}).catch(() => {
					this.mensagem("Não foi possível realizar a consulta !", "Erro", "danger");
				}).finally(() => {
					this.carregando = false;
				});
		},
		limparFormularioFiltro() {
			this.$refs.filtroPessoaFisica.limpar();
			this.$refs.filtroPessoaJuridica.limpar();
			this.cpfPessoaPesquisada = "";
			this.cnpjPessoaPesquisada = "";
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.borda {
    box-shadow: 0px 0px 2px 0px grey;
    min-height: 80vh;
    justify-content: center;
}

h1,
h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}
</style>




// WEBPACK FOOTER //
// src/views/pessoa/GerenciarPessoas.vue